module.exports = __webpack_public_path__ + "img/EDICTOSWEB.64049775.svg";